import i18n from "src/i18n/config";
import { z } from "zod";

import { SimplePolicyRule } from "../types";
import { requiredText } from "../utils";

const kioskPasswordPreference = {
    command: "changePreference",
    package: "com.emteria.kiosk",
    category: "com.emteria.kiosk_preferences",
    key: "prefs_password_key",
    type: "string",
};
const kioskExitPasswordSchema = z.object({ password: requiredText() });

export const kioskExitPassword: SimplePolicyRule<z.infer<typeof kioskExitPasswordSchema>> = {
    id: "kioskExitPassword",
    title: () => i18n.t("modals:addRule.rules.kioskExitPassword.title"),
    description: () => i18n.t("modals:addRule.rules.kioskExitPassword.description"),
    summary: () => i18n.t("modals:addRule.rules.kioskExitPassword.summary"),
    categories: ["kiosk"],
    fields: [
        {
            type: "text",
            name: "password",
            label: () => i18n.t("modals:addRule.rules.kioskExitPassword.password"),
            secret: true,
        },
    ],
    defaultValues: { password: "" },
    schema: kioskExitPasswordSchema,
    command: kioskPasswordPreference,
    toValues: ({ password }) => password,
    fromValues: (password) => ({ password }),
    flags: [],
};
